import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete'
import { FormFieldComponent } from 'src/app/widgets/form-field/form-field.component'
import { SelectFieldProvider } from 'src/app/widgets/select-field/select-field-provider'

@Component({
  selector: 'bdg-autocomplete-field',
  templateUrl: './autocomplete-field.component.html',
})
export class AutocompleteFieldComponent<T extends { id: number | string }>
  extends FormFieldComponent
  implements AfterViewInit {
  @Input() provider: SelectFieldProvider<T>
  @ViewChild(MatAutocompleteTrigger) trigger: MatAutocompleteTrigger
  @Output() invalidEvent: EventEmitter<any> = new EventEmitter()
  text: string

  // representa o id para as opções no select field
  @Input()
  idOption: string

  // representa o id do field
  @Input()
  id: string

  @Output()
  focusEvent: EventEmitter<any> = new EventEmitter()

  @Output()
  selectionChanged: EventEmitter<T> = new EventEmitter()

  constructor() {
    super()
  }

  ngAfterViewInit(): void {
    this.trigger.panelClosingActions.subscribe((e) => {
      this.clearIfInvalid(e)
    })
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    this.selectionChanged.emit(event.option.value)
  }

  clearIfInvalid(event) {
    const value = this.control.value
    let newItem: T | undefined

    if (value && typeof value === 'object') {
      newItem = this.provider.options.find((item) => this.provider.compareWith(item, value as T))
    } else if (typeof value === 'string') {
      newItem = this.provider.options.find((item) => this.provider.description(item) === value)
    }

    if (newItem) {
      this.control.setValue(newItem, { emitEvent: true })
    } else if (!event) {
      this.control.setValue(null, { emitEvent: false })
      this.invalidEvent.emit()
      this.trigger.closePanel()
    }
  }

  onFocusEvent() {
    this.focusEvent.emit()
  }
}
